export default "__VITE_ASSET__Bxc6BMh4__"